import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {

	return {
		wrapper: {
			position: "relative"
		},
		reportedComponnetRoot: {
			backgroundColor           : theme.other.paletteNew.darkModeDarkGrey20,
			textAlign                 : "center",
			borderRadius              : "1rem",
			margin                    : "1rem 0",
			display                   : "flex",
			justifyContent            : "center",
			top                       : "1rem",
			width                     : "calc( 100% - 7rem)",
			scrollSnapAlign           : "center",
			scrollSnapStop            : "always",
			[rooterMediaQuery.mobile] : {
				margin : "1rem",
				width  : "calc( 100vw - 2rem )"
			}
		},
		reelOuterContainer: {
			height                 : "80vh",
			position               : "relative",
			borderRadius           : "1rem",
			// overflow               : "hidden",
			maxWidth               : "100vw",
			aspectRatio            : "9/16",
			scrollSnapAlign        : "start",
			scrollMarginBlockStart : "3rem",
			scrollSnapStop         : "always",

			[rooterMediaQuery.mobile]: {
				background             : "black",
				scrollMarginBlockStart : "0",
				borderRadius           : "0",
				height                 : "100dvh",
				margin                 : "0"
			}
		},
		innerContainer: {
			display       : "flex",
			gap           : "1rem",
			flexDirection : "row",
			height        : "100%",
			alignItems    : "end",

			[rooterMediaQuery.mobile]: {
				gap   : "0",
				width : "100vw"
			}
		},
		videoContainerWrapper: {
			position                  : "relative",
			boxShadow                 : `0px 0px 12px ${ theme.other.paletteNew.darkModeDarkGrey20 }`,
			borderRadius              : "1rem",
			height                    : "100%",
			width                     : "100%",
			touchAction               : "manipulation",
			userSelect                : "none",
			[rooterMediaQuery.mobile] : {
				position: "static"
			}
		},
		inner: {
			display        : "flex",
			gap            : "1rem",
			flexDirection  : "column",
			justifyContent : "center",
			alignItems     : "center",
			padding        : "2rem"
		},
		title: {
			fontWeight                : "500",
			[rooterMediaQuery.mobile] : {
				color: theme.other.colors.text.secondary
			},
			fontSize: "1.5rem"
		},
		subtitle: {
			[rooterMediaQuery.mobile]: {
				color: theme.other.colors.text.secondary
			},
			fontSize: "1.3rem"
		},

		reelsIconWrapper: {
			position     : "absolute",
			display      : "flex",
			padding      : "1rem 1.5rem",
			gap          : "1rem",
			fontSize     : "3rem",
			width        : "calc( 100% - 7rem)",
			overflow     : "hidden",
			alignItems   : "center",
			// width        : "100%",
			borderRadius : "1rem 1rem 0 0",
			zIndex       : 20,

			[rooterMediaQuery.mobile]: {
				padding      : "1.5rem",
				borderRadius : "0",
				top          : "0rem",
				width        : "100%"
			}
		},
		headerText: {
			display    : "flex",
			alignItems : "center",
			gap        : "0.5rem"
		},
		test: {
			height         : "100%",
			width          : "100%",
			zIndex         : -1,
			background     : "none",
			"&[data-show]" : {
				background: "linear-gradient(to bottom, rgba(0, 0, 0, 1) 5%, rgba(0, 0, 0, 0) 83%)"
			},
			opacity      : "0.5",
			borderRadius : "1rem 1rem 0 0",
			position     : "absolute",
			left         : "0",

			[rooterMediaQuery.mobile]: {
				top          : "-1rem",
				borderRadius : "0"
			}
		},
		reelIcon: {
			width      : "3.2rem",
			background : "transparent"
		},
		reelText: {
			textTransform : "uppercase",
			fontSize      : "1.6rem",
			fontWeight    : "500",
			color         : "white"
		}
	};
} );
